<template>
  <div
    class="app-select"
    :style="`width:${width}px`"
  >
    <div
      v-click-outside="hideList"
      class="app-select__selected-item"
      :class="{'app-select__selected-item_opened': open}"
      @click="open = !open"
    >
      <component
        :is="icon"
        v-if="type === 'icon'"
        class="app-select__icon"
      />
      <span
        v-else
        class="app-select__title"
      >
        {{ icon }}
      </span>
      <div
        class="app-select__selected-title"
        :class="{ 'app-select__selected-title_with-icon': !!icon }"
      >
        {{ selectedItem }}
      </div>
    </div>

    <ul
      v-show="open"
      class="select-options"
    >
      <li
        v-for="(option, index) of options"
        :key="index"
        class="select-options__item"
        @click="openList(index)"
      >
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import IconUser from '../Icons/IconUser';
import IconMap from '../Icons/IconMap';
import IconMath from '../Icons/IconMath';
import IconLocation from '../Icons/IconLocation';

export default {
  name: 'AppSelect',
  components: {
    IconUser,
    IconMap,
    IconMath,
    IconLocation,
  },
  directives: {
    ClickOutside,
  },
  model: {
    prop: 'modelProp',
    event: 'select',
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 188,
    },
    modelProp: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedItem: this.options.length > 0 ? this.placeholder : null,
      open: false,
    };
  },
  computed: {
    type() {
      const componentIndex = Object.keys(this.$options.components).findIndex((key) => key === this.icon);
      return componentIndex === -1 ? 'text' : 'icon';
    },
  },
  methods: {
    openList(index) {
      this.selectedItem = this.options[index];
      this.open = true;
      this.$emit('select', this.selectedItem);
    },
    hideList() {
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-select {
    position: relative;
    text-align: left;
    outline: none;
    height: 45px;
    line-height: 45px;

    &__icon {
      margin-left: 16px;
      width: 20px;
      height: 20px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    &__title {
      margin-left: 16px;
      position: absolute;
      font-weight: 700;
      font-size: 15px;
    }

    &__selected-title {
      font-size: 15px;
      height: 45px;
      border-radius: 8px;
      width: 100%;
      padding: 0 10px;
      outline: none;
      transition: all .3s;
      &_with-icon {
        padding-left: 45px;
      }
    }

    &__selected-item {
      background-color: #fff;
      border: 1px solid #606060;
      border-radius: 8px;
      color: #000000;
      cursor: pointer;
      user-select: none;

      &:hover {
        border-color: dodgerblue;
      }

      &:after {
        position: absolute;
        content: "";
        top: 22px;
        right: 15px;
        width: 0;
        height: 0;
        border: 4px solid transparent;
        border-color: #000000 transparent transparent transparent;
      }
      &_opened {
        border: 1px solid dodgerblue;
        border-radius: 8px;
      }
    }
  }

  .select-options {
    max-height: 330px;
    margin-top: 10px;
    color: #000000;
    border-radius: 10px;
    overflow-y: auto;
    position: absolute;
    background-color: #ffffff;
    padding-left: 0;
    left: 0;
    right: 0;
    box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.15);
    z-index: 10;

    &__item {
      color: #000000;
      padding: 0 10px;
      cursor: pointer;
      user-select: none;
      list-style-type: none;

      &:hover {
        color: #ffffff;
        background-color: #1F50FB;
      }
    }
  }

  @media (max-width: 576px) {
    .app-select {
      width: 288px !important;
    }
  }
</style>
